module.exports = __webpack_public_path__ + "sunsemweb/img/cbanner.3282b97e.png";